import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const CSharpLanguageIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M0 1047q0-141 44-262t127-211 199-139 262-51q74 0 148 10t144 41v155q-68-38-141-56t-152-19q-116 0-205 40T276 667t-92 166-32 206q0 104 29 194t86 157 140 105 194 39q86 0 167-19t156-64v141q-79 42-166 57t-176 15q-138 0-246-46t-183-129-114-196-39-246zm1789-217l-56 264h247l-24 93h-241l-78 349h-110l75-349h-219l-74 349h-110l74-349h-231l18-93h233l54-264h-244l18-93h244l74-353h111l-74 353h221l76-353h108l-74 353h231l-20 93h-229zm-109 0h-222l-58 264h223l57-264z" />
    </svg>
  ),
  displayName: 'CSharpLanguageIcon',
});

export default CSharpLanguageIcon;
